// frontend/src/components/CRSFormSections/EducationSection.js
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography
} from '@mui/material';
import {
  BAD_VALUE,
  educationLevelOptions,
  yesNoOptions,
  canadianEducationLevelOptions
} from '../../constants/crsFormOptions'; // Adjust path as needed

function EducationSection({ formData, handleChange, handleFocus, showCanadianEducationLevel }) {
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Typography variant="h6" sx={{ mt: 2 }}>Education</Typography>

      {/* Education Level */}
      <FormControl fullWidth required>
        <InputLabel id="education-level-label">4. What is your level of education?</InputLabel>
        <Select
          labelId="education-level-label"
          name="educationLevel"
          value={formData.educationLevel}
          label="4. What is your level of education?"
          onChange={handleChange}
          onFocus={() => handleFocus('educationLevel')}
        >
          {educationLevelOptions.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Studied in Canada? */}
       <FormControl fullWidth required>
          <InputLabel id="studied-canada-label">4b. Have you earned a Canadian degree, diploma or certificate?</InputLabel>
          <Select
            labelId="studied-canada-label"
            name="studiedInCanada"
            value={formData.studiedInCanada}
            label="4b. Have you earned a Canadian degree, diploma or certificate?"
            onChange={handleChange}
            onFocus={() => handleFocus('studiedInCanada')}
          >
            {yesNoOptions.map(option => (
              <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

      {/* Canadian Education Level (Conditional) */}
      {showCanadianEducationLevel && (
        <FormControl fullWidth required>
          <InputLabel id="canadian-education-level-label">4c. Choose the best answer to describe this level of education.</InputLabel>
          <Select
            labelId="canadian-education-level-label"
            name="canadianEducationLevel"
            value={formData.canadianEducationLevel}
            label="4c. Choose the best answer to describe this level of education."
            onChange={handleChange}
            onFocus={() => handleFocus('canadianEducationLevel')}
          >
            {canadianEducationLevelOptions.map(option => (
              <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
}

export default EducationSection;